import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
// Adds an Authorization header with JWT token to outgoing requests.
export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  const auth = inject(AuthService);

  // Bypass for the request to get the Authorization Token
  if (req.url.indexOf('Auth/generate-token') > -1) return next(req);

  // We should have the token by now; bypass if not.
  if (!auth.accessToken()) {
    console.log(
      `No auth token found. Bypassing auth interceptor for: ${req.url}`,
    );
    return next(req);
  }

  // Add the Authorization Token to the request header.
  const newReq = req.clone({
    headers: req.headers.append(
      'Authorization',
      `Bearer ${auth.accessToken()}`,
    ),
  });
  return next(newReq);
}
